import { useEffect } from "react";

const ensureMeta = (name, attr = "name") => {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  return el;
};

const ensureCanonical = () => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  return el;
};

/* English-only site: keep the self-referencing hreflang pair pointed at the
   current canonical so a JS-rendering crawler never sees them disagree. */
const ensureAlternate = (hreflang) => {
  let el = document.head.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "alternate");
    el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  return el;
};

/**
 * Update <title>, <meta name="description">, OpenGraph + Twitter tags, and <link rel="canonical">
 * each time the calling route mounts or its props change.
 */
export function usePageHead({ title, description, canonicalPath, noindex }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      ensureMeta("description").setAttribute("content", description);
      ensureMeta("og:title", "property").setAttribute("content", title || document.title);
      ensureMeta("og:description", "property").setAttribute("content", description);
      ensureMeta("og:type", "property").setAttribute("content", "website");
      ensureMeta("twitter:card").setAttribute("content", "summary_large_image");
      ensureMeta("twitter:title").setAttribute("content", title || document.title);
      ensureMeta("twitter:description").setAttribute("content", description);
    }
    // Keep robots in sync on every client navigation so a noindex page never
    // leaks its directive to the next route (and vice-versa).
    ensureMeta("robots").setAttribute("content", noindex ? "noindex,nofollow" : "index,follow");
    if (canonicalPath !== undefined) {
      const base = "https://web3readyclarity.com";
      const path = canonicalPath.startsWith("/") ? canonicalPath : `/${canonicalPath}`;
      const url = `${base}${path === "/" ? "" : path}`;
      ensureCanonical().setAttribute("href", url || base);
      ensureMeta("og:url", "property").setAttribute("content", url || base);
      ensureAlternate("en").setAttribute("href", url || base);
      ensureAlternate("x-default").setAttribute("href", url || base);
    }
  }, [title, description, canonicalPath, noindex]);
}
